import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Console } from 'console';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { Goal, GoalCategory, GoalStep } from 'src/app/store/goal/goal.models';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-goal-display',
  templateUrl: './goal-display.component.html',
  styleUrls: ['./goal-display.component.scss']
})
export class GoalDisplayComponent implements OnInit {
  @Input() goalCategory: GoalCategory = null;

  // store controllers
  addingGoal: boolean = false;
  addingGoalError: string = null;
  loadingGoals: boolean = false;
  loadingGoalsError: string = null;
  goals: Goal[] = [];

  addingGoalStep: BehaviorSubject<boolean> = new BehaviorSubject(false);

  stepForm: FormGroup;
  goalForm: FormGroup;
  disabledAddStepButton: boolean = true;
  disabledAddGoalButton: boolean = true;
  eventTransmitter: Observable<any> = new Observable();

  constructor(private goalService: AppService<Goal[]>, private fb: FormBuilder) { }

  ngOnInit(): void {
    this.setupPage();
  }

  private setupPage(): void {
    this.loadingGoals = true;
    this.stepForm = this.fb.group({
      description: new FormControl(null)
    });
    this.stepForm.valueChanges.subscribe(val => this.disabledAddStepButton = val.description === '');

    // set the form for the goal
    this.goalForm = this.fb.group({
      description: new FormControl(null)
    });
    this.goalForm.valueChanges.subscribe(val => this.disabledAddGoalButton = val.description === '');

    this.goalService.get('goals', this.goalCategory.id, { appId: environment.appId })
      .then((goals: Goal[]) => this.goals = goals)
      .catch((error: any) => this.loadingGoalsError = error.message)
      .finally(() => this.loadingGoals = false);
  }

  addGoalStep(goal: Goal): void {
    this.addingGoalStep.next(true);
    const goalStepEntry = { description: this.stepForm.value.description, goal_id: goal.id }
    this.goalService.post('goals', goal.category_id, { appId: environment.appId }, goalStepEntry, true)
      .then((response: GoalStep) => {
        this.goals = [...this.goals.map(g => {
          if (g.id === goal.id) {
            // This is where it need to go
            g.steps = [...g.steps, response];
          }
          return g;
        })];
        this.stepForm.reset();
        this.disabledAddStepButton = true;
      })
      .catch((error: any) => {
        console.log('An error occurred while creating the steps due to', error);
      }).finally(() => this.addingGoalStep.next(false));
  }

  private updateGoalStep(goal: Goal, step: GoalStep, params: any): void {
    this.goalService.put('goals', `${goal.category_id}/${goal.id}/${step.id}`, { appId: environment.appId }, params)
      .then((response: GoalStep) => {
        this.goals = [
          ...this.goals.map(g => {
            if (g.id === goal.id) {
              g.steps = [...g.steps.map(s => s.id === response.id ? response : s)]
            }
            return g;
          })
        ];
      })
      .catch((error: any) => {
        console.log(error);
      })
  }

  private deleteGoalStep(goal: Goal, step: GoalStep): void {
    this.goalService.delete('goals', `${goal.category_id}/${goal.id}/${step.id}`, { appId: environment.appId })
      .then(() => {
        this.goals = [
          ...this.goals.map(g => {
            if (g.id === goal.id) {
              g.steps = [...g.steps.filter(s => s.id !== step.id)]
            }
            return g;
          })
        ];
      })
      .catch((error: any) => {
        console.log(error);
      })
  }

  toggleStatus(data: any, goal: Goal): void {
    let params = {};
    if (data.action === 'TOGGLE_STATUS') {
      params = {
        description: data.data.description,
        status: data.data.status === 'COMPLETED' ? null : 'COMPLETED'
      }
      this.updateGoalStep(goal, data.data, params);
    } else if (data.action === 'UPDATE_STEP') {
      params = {
        status: data.data.status,
        description: data.data.description
      }
      this.updateGoalStep(goal, data.data, params);
    } else if (data.action === 'DELETE_STEP') {
      this.deleteGoalStep(goal, data.data);
    } else {
      return;
    }
  }

  addGoal(): void {
    const description = this.goalForm.value.description;
    if (description) {
      const goalEntry = {
        description,
        category_id: this.goalCategory.id,
      };
      this.goalService.post('goals', '', { appId: environment.appId }, goalEntry, true)
        .then((response) => {
          this.goals.push(response);
          this.goalForm.reset();
        })
        .catch((error: any) => this.addingGoalError = error.message)
    }
  }

}
